let initializeDoughnutChart = function(chartId) {
  if (document.getElementById(chartId)) {
    var data = $('#' + chartId).data('doughnut-chart-data');

    data['datasets'][0]['backgroundColor'] = [
      '#155893',
      '#3FAAE1',
      '#1A2476',
      '#DFEEF8',
      '#EFEFEF'
    ];
    data['datasets'][0]['borderRadius'] = [
      '6'
    ];

    var config = {
      type: 'doughnut',
      data: data,
      options: {
        cutout: '75%',
        radius: "100%",
        aspectRatio: 1.1,
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
            maxWidth: 230,
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              boxWidth: 10,
              font: {
                size: 10,
                weight: 'bold',
              }
            }
          }
        }
      },
    };

    new Chart(
      document.getElementById(chartId),
      config
    );
  }
};

let initializeBarChart = function(chartId, scope, graphInFuture, maintainAspectRatio = false, isResponsive = true) {
  if (document.getElementById(chartId)) {
    const chart = document.getElementById(chartId);
    const data  = JSON.parse(chart.dataset.barChartData);

    if (scope && scope != "all") {
      if (graphInFuture) {
        data.labels = data.labels.slice(0, scope);

        data.datasets.forEach(element => {
          element.data = element.data.slice(0, scope);
          element.description = element.description.slice(0, scope);
        });
      } else {
        data.labels = data.labels.slice(-scope);
        data.datasets.forEach(element => {
          element.data = element.data.slice(-scope);
          element.description = element.description.slice(-scope);
        });
      }
    };
    const config = {
      type: 'bar',
      data: data,
      options: {
        aspectRatio: 3|3,
        maintainAspectRatio: maintainAspectRatio,
        responsive: isResponsive,
        scales: {
          x: {
            stacked: true,
            ticks: {
              maxRotation: 30,
              minRotation: 30,
            }
          },
          y: {
            stacked: true,
            ticks: {
              callback: function(label) {
                if (label >= 1000) {
                  return `${label / 1000}k`
                } else {
                  return label;
                }
              }
            }
          }
        },
        plugins: {
          tooltip: {
            position: 'cursor',
            callbacks: {
              label: function(context) {
                const contextIndex = context.datasetIndex;
                const currentContext = context.dataset.description[context.dataIndex];

                const labels = Object.entries(currentContext).reduce(
                  (formattedLabels, projects) => {
                    const projectName = projects[0];
                    const value = Object.values(projects[1])[contextIndex];

                    if (!!value) {
                      formattedLabels.push(`${projectName} : ${value}`);
                    }
                    return formattedLabels;
                  },
                  []
                );
                return labels;
              }
            }
          }
        }
      }
    };

    new Chart(
      document.getElementById(chartId),
      config
    );
  }
};

let initializeBarChartOverdue = function(chartId) {
  if (document.getElementById(chartId)) {
    const chart = document.getElementById(chartId);
    const data  = JSON.parse(chart.dataset.barChartData);

    data.labels = data.labels.slice(0);
    data.datasets.forEach(element => {
      element.data = element.data.slice(0);
      element.description = element.description.slice(0);

    });
    const config = {
      type: 'bar',
      data: data,
      options: {
        barThickness: 20,
        aspectRatio: 0.3,
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          x: {
            stacked: true,
            ticks: {
              display: true,
              maxRotation: 30,
              minRotation: 30
            }
          },
          y: {
            stacked: true,
            ticks: {
              display: true,
              callback: function(label) {
                if (label >= 1000) {
                  return `${label / 1000}k`
                } else {
                  return label;
                }
              }
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false,
            position: 'cursor',
            external: externalTooltipHandler
          }
        }
      }
    };

    new Chart(
      document.getElementById(chartId),
      config
    );
  }
};

Chart.Tooltip.positioners.cursor = function(chartElements, coordinates) {
  return coordinates;
};

$(document).ready(function () {
  initializeDoughnutChart('operationTypeChart');
  initializeDoughnutChart('regionChart');
  initializeDoughnutChart('projectOwnerTypeChart');

  var termsBarChartSelected = $("#termsBarChart").find(":selected").val();
  var subscriptionsBarChartSelected = $("#subscriptionsBarChart").find(":selected").val();

  initializeBarChart('projectOwnerBarChart', termsBarChartSelected, true);
  initializeBarChartOverdue('projectOwnerBarChartOverdue');

  initializeBarChart('assetManagementAdvisorMasterBarChart', subscriptionsBarChartSelected, false, true);

  $("#termsBarChart").on('change', function() {
    Chart.getChart("projectOwnerBarChart").destroy();

    initializeBarChart('projectOwnerBarChart', $(this).val(), true);
  });

  $("#subscriptionsBarChart").on('change', function () {
    Chart.getChart("assetManagementAdvisorMasterBarChart").destroy();

    initializeBarChart('assetManagementAdvisorMasterBarChart', $(this).val(), false, true);
  });
});

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
    tooltipEl.style.borderRadius = '3px';
    tooltipEl.style.color = 'white';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.transform = 'translate(-40%, 0)';
    tooltipEl.style.transition = 'all .1s ease';
    tooltipEl.style.zIndex = '9999';
    tooltipEl.style.fontSize = '12px';
    tooltipEl.style.overflow = 'visible';
    tooltipEl.style.width = 'auto';
    tooltipEl.style.minWidth = '250px';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const externalTooltipHandler = (context) => {
  // Tooltip Element
  const {chart, tooltip} = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const context = tooltip.dataPoints[0];
    const contextIndex = context.datasetIndex;
    const currentContext = context.dataset.description;

    const labels = Object.entries(currentContext).reduce(
      (formattedLabels, projects) => {
        const projectName = Object.keys(projects[1])[0];
        const value = Object.values(projects[1][projectName])[contextIndex]
        if (!!value && parseFloat(value) !== 0) {
          formattedLabels.push(`${projectName} : ${value}`);
        }
        return formattedLabels;
      },
      []
    );

    const tableHead = document.createElement('thead');
    const tableBody = document.createElement('tbody');

    labels.forEach((body, i) => {
      const colors = tooltip.labelColors[0];

      const span = document.createElement('span');
      span.style.background = colors.backgroundColor;
      span.style.border = "1px solid #fff";
      span.style.marginLeft = '0';
      span.style.marginRight = '4px';
      span.style.marginTop = '0px';
      span.style.marginBottom = '0px';
      span.style.padding = '0px';
      span.style.height = '8px';
      span.style.width = '8px';
      span.style.display = 'inline-block';

      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = 0;

      const td = document.createElement('td');
      td.style.borderWidth = 0;
      td.style.padding = 0;
      td.style.paddingBottom = '3px';
      const text = document.createTextNode(body);

      td.appendChild(span);
      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  tooltipEl.style.font = tooltip.options.bodyFont.string;
  tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};
